import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, ClipboardCheck, BookOpen } from "lucide-react";

const paths: Array<{ to: string; icon: typeof HeartHandshake; label: string; blurb: string; anchor?: string; cta: string }> = [
  {
    to: "/services",
    icon: HeartHandshake,
    label: "I need care for a parent",
    blurb: "See what companion care includes, how matching works, and what a week of support looks like.",
    anchor: "See our care packages",
    cta: "See our care menu",
  },
  {
    to: "/tools/caregiver-burnout-check",
    icon: ClipboardCheck,
    label: "I'm the one doing the caring",
    blurb: "Take the free 2-minute burnout self-check — no email required, honest results right away.",
    cta: "Start the self-check",
  },
  {
    to: "/shop",
    icon: BookOpen,
    label: "I just want help figuring this out",
    blurb: "Guides, planners, and our caregiver kit — practical tools you can download today.",
    cta: "Browse the shop",
  },
];

const QuickPaths = () => (
  <section className="py-14 md:py-20 bg-card border-b border-border" aria-labelledby="quick-paths-heading">
    <div className="container">
      <h2 id="quick-paths-heading" className="text-2xl md:text-3xl font-heading italic text-primary text-center mb-3 tracking-wide">
        Where would you like to start?
      </h2>
      <p className="text-center text-muted-foreground mb-14 font-light">
        Three common places families begin. Pick whichever sounds most like you.
      </p>
      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {paths.map((p) => (
          <Link
            key={p.to}
            to={p.to}
            className="group relative flex flex-col bg-background border border-border p-10 overflow-hidden hover:border-warm hover:shadow-xl transition-all duration-500"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-warm scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" aria-hidden="true" />
            <p.icon className="h-6 w-6 text-warm-ink mb-5" aria-hidden="true" />
            <h3 className="font-heading font-semibold text-xl text-primary mb-3 leading-snug">{p.label}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-2 flex-1 font-light">{p.blurb}</p>
            {p.anchor && (
              <p className="text-sm font-medium text-warm-ink mb-3">{p.anchor}</p>
            )}
            <span className="mt-5 inline-flex items-center text-[11px] tracking-[0.2em] uppercase text-warm-ink font-bold">
              {p.cta} <ArrowRight className="h-3.5 w-3.5 ml-1 group-hover:translate-x-0.5 transition-transform" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
      <p className="text-center text-muted-foreground font-light mt-10">
        Wondering about cost first?{" "}
        <Link to="/resources/cost-of-companion-care-nashville" className="underline underline-offset-4 text-warm-ink">
          Read: what companion care costs in Nashville
        </Link>
      </p>
    </div>
  </section>
);

export default QuickPaths;
